import React from "react";
import { MdKeyboardArrowRight } from "react-icons/md";

function About() {
  return (
    <div className="md:container md:mx-auto flex md:justify-between sm:justify-center md:h-60 mt-12">
      <div className="image">
        <img
          className="w-full h-full sm:hidden md:block"
          src="https://www.chemengonline.com/wp-content/uploads/2018/01/manual-workers-working.jpg"
          alt=""
        />
      </div>
      <div className="content md:w-2/4 sm:mx-16 md:mx-0 flex flex-col md:gap-y-0 sm:gap-y-8 justify-between ">
        <h1 className="inline-block border-b-2 border-first text-2xl font-bold uppercase">
          Haqqımızda
        </h1>
        <p className="text-sm">
          Archbaku MMC 25 sentyabr 2019 cu ildən təcrübəli mütəxəssis heyəti ilə
          xidmət göstərən tikinti şirkətidir. İqtisadiyyatın ən önəmli
          sahələrindən biri olan infrastruktur sektorunda daim yeniliklərə,
          inkişafa önəm vermişik.
          <br />
          <br /> Bizim ən önəmli missiyamız yüksək keyfiyyətli tikinti və
          mühəndislik təcrübəmizdən istifadə edərək ən son texnikalarla
          müştərilərimizin etimadını qazanmaqdır.
        </p>
        <button className="flex justify-center rounded-md md:w-40 sm:w-32 text-white bg-first px-7 py-3">
          Ətraflı
          <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
        </button>
      </div>
    </div>
  );
}

export default About;
